<template lang="pug">
b-modal#approval-rejection-modal(
  title="Reject Request"
  size="lg"
  centered
  @ok="handleReject"
  @cancel="handleCancel"
  :ok-disabled="!rejectionReason.trim()"
)
  template(#modal-header)
    h5.modal-title
      Icon.text-danger(icon="tabler:alert-circle")
      | Reject Request

  .rejection-form
    b-alert.mb-3(show variant="warning")
      Icon(icon="tabler:info-circle")
      | Please provide a reason for rejecting this request. This will be visible to the client.

    b-form-group(
      label="Rejection Reason"
      label-for="rejection-reason"
      description="Required field - minimum 10 characters"
    )
      b-form-textarea#rejection-reason(
        v-model="rejectionReason"
        placeholder="Enter the reason for rejection..."
        rows="4"
        max-rows="8"
        required
        :state="rejectionReason.length >= 10 ? true : rejectionReason.length > 0 ? false : null"
      )
      b-form-invalid-feedback(:state="rejectionReason.length >= 10")
        | Rejection reason must be at least 10 characters long

    .request-summary.mt-3.p-3.bg-light.rounded
      h6 Request Summary
      div
        strong Client: 
        | {{ requestSummary.clientName }}
      div
        strong Type: 
        | {{ requestSummary.type }}
      div
        strong Original Date: 
        | {{ requestSummary.originalDate }}

  template(#modal-footer="{ ok, cancel }")
    b-button(variant="secondary" @click="cancel") Cancel
    b-button(
      variant="danger"
      @click="ok"
      :disabled="!rejectionReason.trim() || rejectionReason.length < 10"
    )
      Icon(icon="tabler:x")
      | Reject Request
</template>

<script>
import { Icon } from '@iconify/vue2';
import dayjs from 'dayjs';

export default {
  name: 'ApprovalRejectionModal',
  components: {
    Icon
  },
  props: {
    request: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      rejectionReason: ''
    };
  },
  computed: {
    requestSummary() {
      if (!this.request) return {};
      return {
        clientName: this.request.crb5c_ClientLookup?.crb5c_name || 'N/A',
        type: this.request.crb5c_requesttype === 0 ? 'Session Swap' : 'MC Request',
        originalDate: this.request.crb5c_originaldate 
          ? dayjs(this.request.crb5c_originaldate).format('DD MMM YYYY')
          : 'N/A'
      };
    }
  },
  methods: {
    handleReject() {
      if (this.rejectionReason.trim() && this.rejectionReason.length >= 10) {
        this.$emit('reject', this.rejectionReason.trim());
        this.resetForm();
      }
    },
    handleCancel() {
      this.resetForm();
    },
    resetForm() {
      this.rejectionReason = '';
    }
  }
};
</script>

<style scoped>
.rejection-form {
  padding: 0.5rem 0;
}

.request-summary {
  border-left: 3px solid #dc3545;
}

.request-summary h6 {
  margin-bottom: 0.75rem;
  font-weight: 600;
}

.request-summary div {
  margin-bottom: 0.25rem;
}
</style>
